<template>
  <div class="nav">
    <ul class="app-header-nav  ">
      <li class="item">
        <RouterLink class="link" to="/">首页</RouterLink>
      </li>
      <li
          class="item"
          v-for="item in dataList"
          :key="item.id"
          @mouseenter="show(item)"
          @mouseleave="hide(item)"
      >
<!--        <RouterLink class="link" :to="'/category/'+item.id" @click="hide(item)">{{ item.name }}</RouterLink>-->
        <RouterLink class="link" :to="'/'+item.to" @click="hide(item)">{{ item.name }}</RouterLink>

        <!-- 弹出层 -->
        <div class="layer" :class="{active:item.open}">
          <a href="#" v-for="ele in item.subList" :key="ele.id">
            {{ ele.name }}
          </a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
// import {useStore} from "vuex";
// import {computed} from "vue";

export default {

  data(){
    return {

      dataList : [
        {
          "id": "1",
          "name": "科技资源",
          "open": true,
          "to":"patent",
          "subList": [
            /*{
              "id": "100",
              "name": "专利检索"
            },
            {
              "id": "1001",
              "name": "软著检索"
            }*/
          ]
        },
        {
          "id": "2",
          "name": "技术供应",
          "open": true,
          "to":"sales",
        },
        {
          "id": "3",
          "name": "需求发布",
          "open": true,
          "to":"requirement",
        },
        {
          "id": "4",
          "name": "专家团队",
          "open": true,
          "to":"team",
        },
        {
          "id": "5",
          "name": "专题库",
          "open": true,
          "to":"library",
        },
        {
          "id": "6",
          "name": "关于我们",
          "open": true,
          "to":"about",
        },
        {
          "id": "7",
          "name": "联系我们",
          "open": true,
          "to":"contact",
        },
        {
          "id": "8",
          "name": "新闻动态",
          "open": true,
          "to":"news",
        }
      ]
    }
  },
  setup(props) {
    // const store = useStore();
    // // 从仓库里读取分类列表
    // const list = computed(() => {
    //   return store.state.category.cateList;
    // });


    // 鼠标进入显示
    const show = item => {
      item.open = true;
    };
    // 鼠标离开，点击二级菜单后隐藏
    const hide = item => {
      item.open = false;
    };

    return { show, hide};
  }
};
</script>

<style lang="less" scoped>

.nav {
  margin: 10px 0 0 0;

  .app-header-nav {
    display: flex;
    justify-content: space-around;


    .item {
      position: relative;
      padding: 0 10px;
      font-weight: bold;
      line-height: 40px;
      z-index: 999;
      // 选中高亮设置
      .router-link-exact-active {
        color: @xtxColor;
        border-bottom: 2px solid @xtxColor;
      }

      .link {
        padding-bottom: 7px;
        font-size: 20px;
      }
      //划过
      &:hover {
        .link {
          color: @xtxColor;
          border-bottom: 2px solid @xtxColor;
        }
        .layer {
          opacity: 0;
        }
        .active {
          opacity: 1;
        }
      }
    }

    .layer {
      position: absolute;
      left: 0;
      opacity: 0;
      height: auto;
      width: 120px;
      background-color: #fff;
      box-shadow: 0 0 5px #ccc;
      transition: all 0.5s;
      a {
        display: block;
        border-bottom: 0;
        height: 40px;
        line-height: 40px;
        padding: 0 15px;
        letter-spacing: 1px;
        font-size: 16px;
        &:hover {
          background-color: #90B7DB;
        }
      }
    }
  }
}

</style>